import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Clock, ShieldCheck } from 'lucide-react';

const ROIIntroSlide = () => {
  return (
    <div className="h-full w-full bg-slate-900 flex items-center justify-center p-8 relative overflow-hidden">
      {/* Background Gradients */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-blue-600/20 rounded-full blur-[100px]" />
        <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-indigo-600/20 rounded-full blur-[100px]" />
      </div>

      <div className="max-w-5xl relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/10 text-blue-400 text-sm font-semibold mb-8 border border-blue-500/20">
            <TrendingUp className="w-4 h-4" />
            <span>ROI & Impact</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-medium text-white leading-tight mb-12 tracking-tight">
            The average single dental practice sees a <span className="text-blue-400 font-bold">$7,700 increase</span> in production in the first month.
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mt-16">
             <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 rounded-2xl flex flex-col items-center">
                <div className="w-12 h-12 bg-blue-500/20 rounded-full flex items-center justify-center mb-4 text-blue-400">
                    <TrendingUp className="w-6 h-6" />
                </div>
                <div className="text-3xl font-bold text-white mb-1">$7,700+</div>
                <div className="text-sm text-slate-400">Monthly Production Increase</div>
             </div>
             
             <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 rounded-2xl flex flex-col items-center">
                <div className="w-12 h-12 bg-indigo-500/20 rounded-full flex items-center justify-center mb-4 text-indigo-400">
                    <Clock className="w-6 h-6" />
                </div>
                <div className="text-3xl font-bold text-white mb-1">15+</div>
                <div className="text-sm text-slate-400">Hours Saved Every Week</div>
             </div>

             <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 rounded-2xl flex flex-col items-center">
                <div className="w-12 h-12 bg-emerald-500/20 rounded-full flex items-center justify-center mb-4 text-emerald-400">
                    <ShieldCheck className="w-6 h-6" />
                </div>
                <div className="text-3xl font-bold text-white mb-1">100%</div>
                <div className="text-sm text-slate-400">Missed Calls Handled</div>
             </div>
          </div>

          <div className="mt-24 w-full">
            <p className="text-slate-400 text-sm font-semibold uppercase tracking-widest mb-10">Trusted by Practices across the country</p>
            
            <div className="relative flex overflow-hidden group mask-image-linear-gradient">
                <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-slate-900 to-transparent z-10" />
                <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-slate-900 to-transparent z-10" />
                
                <motion.div 
                    className="flex gap-16 items-center whitespace-nowrap"
                    animate={{ x: "-50%" }}
                    transition={{ 
                        duration: 40, 
                        ease: "linear", 
                        repeat: Infinity 
                    }}
                >
                    {[...logos, ...logos, ...logos, ...logos].map((logo, idx) => (
                        <img 
                            key={idx} 
                            src={logo} 
                            alt={`Practice Logo ${idx}`} 
                            className="h-16 w-auto object-contain opacity-40 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-300"
                        />
                    ))}
                </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

const logos = [
  "/assets/practicelogos/image 1.png",
  "/assets/practicelogos/image 2.png",
  "/assets/practicelogos/image 3.png",
  "/assets/practicelogos/image 4.png",
  "/assets/practicelogos/image 5.png",
  "/assets/practicelogos/image 6.png",
];

export default ROIIntroSlide;























